export const APP_STARTUP_READY_EVENT = "ultrack:app-ready";

export function AppStartupScreen() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black">
      <style>{`
        .startup-accent { background: #dc2626; }
        .theme-orange .startup-accent { background: #f97316; }
        .theme-green .startup-accent { background: #16a34a; }
        .theme-purple .startup-accent { background: #9333ea; }
        .theme-red .startup-accent { background: #dc2626; }
        .theme-pastel-mint .startup-accent { background: #8dd8c8; }
        .theme-pastel-peach .startup-accent { background: #f2b79e; }
        .theme-pastel-lilac .startup-accent { background: #c8b5ee; }
        .theme-pastel-rose .startup-accent { background: #efaec3; }
        .dark.theme-pastel-mint .startup-accent { background: #16a34a; }
        .dark.theme-pastel-peach .startup-accent { background: #f97316; }
        .dark.theme-pastel-lilac .startup-accent { background: #9333ea; }
        .dark.theme-pastel-rose .startup-accent { background: #dc2626; }
      `}</style>
      <div className="startup-inner flex flex-col items-center gap-3.5">
        <div
          className="font-mono text-[clamp(28px,6vw,36px)] font-semibold uppercase tracking-[0.38em] text-white"
          aria-label="ULTRACK"
        >
          ULTRACK
        </div>
        <div className="startup-accent h-0.5 w-8 rounded-full opacity-60" />
      </div>
    </div>
  );
}
